import React, { useState, useEffect } from 'react';
import { FaCheckCircle, FaClock, FaTimesCircle } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { fetchAPI } from '../../utils/api';
import { useNavigate } from 'react-router-dom';

export default function RecentPaymentsWidget() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadPayments = async () => {
            if (!currentUser) return;
            try {
                const data = await fetchAPI(`/payment/get_submissions.php?user_id=${currentUser.id}`);
                setPayments(data);
            } catch (err) {
                console.error("Failed to load recent payments", err);
            } finally {
                setLoading(false);
            }
        };
        loadPayments();
    }, [currentUser]);

    const getStatusIcon = (status) => {
        switch (status) {
            case 'Approved': return <FaCheckCircle className="text-emerald-500" size={14} />;
            case 'Pending': return <FaClock className="text-amber-500" size={14} />;
            case 'Rejected': return <FaTimesCircle className="text-rose-500" size={14} />;
            default: return null;
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'Approved': return 'text-emerald-600';
            case 'Pending': return 'text-amber-600';
            case 'Rejected': return 'text-rose-600';
            default: return 'text-gray-600';
        }
    };

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-blue-50/50 p-6 relative overflow-hidden hover:shadow-md transition-all duration-300">
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-emerald-50 text-emerald-600 rounded-lg">
                        <FaCheckCircle size={14} />
                    </div>
                    <h2 className="text-lg font-bold text-gray-900">Recent Payments</h2>
                </div>
                <button
                    onClick={() => navigate('/dashboard/payments')}
                    className="text-xs font-bold text-gray-500 hover:text-gray-900 bg-gray-50 px-3 py-1.5 rounded-full transition-colors"
                >
                    History
                </button>
            </div>

            <div className="space-y-3">
                {loading ? (
                    <div className="space-y-3">
                        <div className="h-14 bg-gray-50 animate-pulse rounded-xl"></div>
                        <div className="h-14 bg-gray-50 animate-pulse rounded-xl"></div>
                    </div>
                ) : payments.length === 0 ? (
                    <div className="py-6 text-center text-gray-400 text-sm font-medium">
                        No payments found
                    </div>
                ) : (
                    payments.slice(0, 3).map((payment, idx) => (
                        <div key={idx} className="flex items-center justify-between p-3 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100 group">
                            <div className="flex flex-col">
                                <h4 className="text-sm font-bold text-gray-900 truncate max-w-[150px] md:max-w-[200px]">{payment.month_name}</h4>
                                <span className={`text-[10px] font-bold flex items-center gap-1.5 mt-0.5 ${getStatusColor(payment.status)}`}>
                                    {getStatusIcon(payment.status)}
                                    {payment.status.toUpperCase()} • {new Date(payment.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                                </span>
                            </div>
                            <span className="text-sm font-black text-gray-900 bg-gray-100 group-hover:bg-white px-2.5 py-1 rounded-lg border border-transparent group-hover:border-gray-200 transition-all">
                                LKR {payment.amount}
                            </span>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
